<template>
  <v-container>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md6 lg5 xl4>
        <v-card>
          <v-card-title></v-card-title>

          <v-card-text>
            <v-form v-model="valid">
              <v-layout justify-space-between wrap>
                <v-flex xs6>
                  <v-text-field
                    label="Sunucu"
                    placeholder="IP veya Alan Adı"
                    v-model="form.host"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs2>
                  <v-text-field
                    label="Port"
                    type="number"
                    v-model="form.queryport"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>

                <v-flex xs3>
                  <v-checkbox v-model="form.ssh" label="SSH">
                    <template #append>
                      <v-tooltip bottom>
                        <template #activator="{ on }">
                          <v-icon v-on="on">mdi-help-circle-outline</v-icon>
                        </template>
                        <span>
                          SSH işaretliyse (varsayılan), ServerQuery bağlantısı
                          şifreli olur.
                        </span>
                      </v-tooltip>
                    </template>
                  </v-checkbox>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    label="Kullanıcı Adı"
                    v-model="form.username"
                    :rules="[rules.required]"
                    placeholder="örn. serveradmin"
                    name="username"
                    autocomplete="username"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-text-field
                    ref="passwordInput"
                    label="Şifre"
                    type="password"
                    v-model="form.password"
                    :rules="[rules.required]"
                    name="password"
                    autocomplete="current-password"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-checkbox
                    label="Beni Hatırla"
                    v-model="rememberLogin"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>

            <!-- ✅ KAYITLI SUNUCULAR -->
            <v-divider class="my-4" />

            <div class="d-flex align-center">
              <div class="text-subtitle-2">Kayıtlı Sunucular</div>
              <v-spacer />
              <v-btn
                small
                outlined
                color="primary"
                @click="openSaveProfileDialog"
              >
                <v-icon left small>bookmark_add</v-icon> Profil Kaydet
              </v-btn>
            </div>

            <v-alert
              v-if="!profiles.length"
              dense
              text
              type="info"
              class="mt-2"
            >
              Henüz profil yok. “Profil Kaydet” ile ekleyebilirsin.
            </v-alert>

            <v-list v-else dense class="mt-2">
              <v-list-item
                v-for="p in profiles"
                :key="p.id"
                @dblclick="useProfile(p)"
                style="cursor: pointer"
              >
                <v-list-item-content>
                  <v-list-item-title class="text-truncate">
                    {{ p.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-truncate">
                    {{ p.host }} :{{ p.queryport }} ({{
                      p.ssh ? "ssh" : "raw"
                    }}) • {{ p.username }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    small
                    color="error"
                    @click.stop="deleteProfile(p.id)"
                    title="Sil"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <div class="caption mt-2" style="opacity: 0.75">
              İpucu: Bir profile <b>çift tıkla</b>, alanlar otomatik dolsun.
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              :disabled="!valid"
              @click="connect"
              :loading="loading"
            >
              <v-icon>arrow_forward</v-icon>Bağlan
              <template #loader>
                <span>Bağlanılıyor...</span>
              </template>
            </v-btn>
          </v-card-actions>

          <span :style="{ color: '#BDBDBD', marginLeft: '5px' }">
            Sürüm {{ appVersion }}
          </span>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ✅ PROFİL KAYDET DIALOG -->
    <v-dialog v-model="profileDialog" max-width="520">
      <v-card>
        <v-card-title class="py-2">
          Profil Kaydet
          <v-spacer />
          <v-btn icon @click="profileDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="newProfileName"
            label="Profil Adı"
            dense
            outlined
            placeholder="örn. PaladinsGaming"
          />

          <v-alert dense text type="info">
            Şifre kaydedilmez. (Güvenlik)
          </v-alert>

          <div class="caption" style="opacity: 0.8">
            Kaydedilecek: host, port, ssh/raw, username
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="profileDialog = false">İptal</v-btn>
          <v-btn color="primary" @click="saveCurrentAsProfile">
            <v-icon left>save</v-icon> Kaydet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { version } from "../../../../package.json";

const PROFILES_KEY = "ts3_saved_servers_v1";

function loadProfilesLS() {
  try {
    const raw = localStorage.getItem(PROFILES_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}
function saveProfilesLS(list) {
  localStorage.setItem(PROFILES_KEY, JSON.stringify(list || []));
}

export default {
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      let token = vm.$store.state.query.token;

      vm.$store.commit("isLoggedOut", true);

      // ✅ localstorage profilleri yükle
      vm.profiles = loadProfilesLS();

      if (!token) return;

      vm.$socket.emit("autofillform", token, (response) => {
        if (response.host) {
          vm.form.host = response.host;
          vm.form.queryport = response.queryport;
          vm.form.ssh = response.protocol === "ssh";
          vm.form.username = response.username;
          vm.form.password = response.password;
        } else {
          vm.$store.dispatch("removeToken");
          vm.$toast.error(response);
        }
      });
    });
  },

  data() {
    return {
      panel: [true],
      valid: false,
      loading: false,
      rules: {
        required: (value) => !!value || "Zorunlu alan.",
      },
      form: {
        host: "",
        queryport: 10022,
        ssh: true,
        username: "",
        password: "",
      },
      appVersion: version,

      // ✅ Profiles UI
      profiles: [],
      profileDialog: false,
      newProfileName: "",
    };
  },

  computed: {
    rememberLogin: {
      set(value) {
        this.$store.commit("setRememberLogin", value);
      },
      get() {
        return this.$store.state.settings.rememberLogin;
      },
    },
  },

  methods: {
    // ---------- Profiles
    openSaveProfileDialog() {
      // isim öner
      const h = (this.form.host || "").trim();
      this.newProfileName = h ? h : "Sunucu";
      this.profileDialog = true;
    },

    saveCurrentAsProfile() {
      const name = String(this.newProfileName || "").trim() || "Sunucu";
      const host = String(this.form.host || "").trim();
      const queryport = Number(this.form.queryport || 0);
      const ssh = !!this.form.ssh;
      const username = String(this.form.username || "").trim();

      if (!host || !queryport || !username) {
        this.$toast.error("Host/Port/Kullanıcı adı boş olamaz.");
        return;
      }

      const id = Date.now() + "_" + Math.floor(Math.random() * 9999);
      const p = {
        id,
        name,
        host,
        queryport,
        ssh,
        username,
        lastUsedAt: Date.now(),
      };

      // aynı host+port+username varsa güncelle
      const list = loadProfilesLS();
      const i = list.findIndex(
        (x) =>
          x.host === p.host &&
          Number(x.queryport) === Number(p.queryport) &&
          x.username === p.username &&
          !!x.ssh === !!p.ssh
      );

      if (i >= 0) list[i] = { ...list[i], ...p, id: list[i].id };
      else list.unshift(p);

      saveProfilesLS(list);
      this.profiles = list;

      this.profileDialog = false;
      this.$toast.success("Profil kaydedildi.");
    },

    deleteProfile(id) {
      const list = loadProfilesLS().filter((x) => x.id !== id);
      saveProfilesLS(list);
      this.profiles = list;
      this.$toast.success("Silindi.");
    },

    useProfile(p) {
      this.form.host = p.host;
      this.form.queryport = Number(p.queryport);
      this.form.ssh = !!p.ssh;
      this.form.username = p.username;

      // şifreyi elle gireceksin; focus atalım
      this.$nextTick(() => {
        const r = this.$refs.passwordInput;

        if (r && typeof r.focus === "function") {
          r.focus();
          return;
        }

        if (r && r.$el) {
          const inp = r.$el.querySelector("input");
          if (inp && typeof inp.focus === "function") {
            inp.focus();
          }
        }
      });
    },

    // ---------- Existing connect logic
    connectTeamSpeak(credentials) {
      return this.$TeamSpeak.connect(credentials);
    },

    async connect() {
      this.loading = true;

      try {
        let { token } = await this.connectTeamSpeak({
          host: this.form.host,
          queryport: this.form.queryport,
          protocol: this.form.ssh ? "ssh" : "raw",
          username: this.form.username,
          password: this.form.password,
        });

        this.$store.dispatch("saveToken", token);
        this.$store.commit("isConnected", true);
        this.$store.commit("isLoggedOut", false);

        this.$router.push({ name: "servers" });
      } catch (err) {
        this.$toast.error(err.message);
      }

      this.loading = false;
    },
  },

  watch: {
    "form.ssh"(ssh) {
      this.form.queryport = ssh ? 10022 : 10011;
    },
  },
};
</script>

<style>
.v-expansion-panel__header {
  padding: 0 !important;
}
</style>
